import { generatePath } from 'react-router-dom';
import { ApiCacheTags, baseApiService } from '@qapline/api';
import { DEFAULT_CONFIG } from '@qapline/config';

import { customerContactSchema, TCustomerContact } from '../schemas';
import { TGetCustomerContactRequestBody, TListCustomerContactsRequestBody } from '../types';

const { get: getEndpoint, list: listEndpoint } = DEFAULT_CONFIG.api.endpoints.customerContact;
const { item: itemTag, list: listTag } = ApiCacheTags.customerContact;

export const customerContactApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        listCustomerContacts: builder.query<TCustomerContact[], TListCustomerContactsRequestBody>({
            query: ({ customerId }) => ({
                url: generatePath(listEndpoint, { customerId: customerId.toString() }),
                method: 'GET',
            }),
            providesTags: (_res, error, { customerId }) => (error ? [] : [{ type: listTag, id: customerId }]),
            transformResponse: (data) => customerContactSchema.array().parse(data),
        }),
        getCustomerContact: builder.query<TCustomerContact, TGetCustomerContactRequestBody>({
            query: ({ customerContactId }) => ({
                url: generatePath(getEndpoint, { customerContactId: customerContactId.toString() }),
                method: 'GET',
            }),
            providesTags: (_res, error, { customerContactId }) =>
                error ? [] : [{ type: itemTag, id: customerContactId }],
            transformResponse: (data) => customerContactSchema.parse(data),
        }),
    }),
});

export const {
    useGetCustomerContactQuery,
    useLazyGetCustomerContactQuery,
    useListCustomerContactsQuery,
    useLazyListCustomerContactsQuery,
} = customerContactApi;
